<template>
<div class="chapter">
<div class="inner_page">
<p class="C2909"><span class="small"><span id="page_33">P</span>ART ONE </span></p>
<p class="C2831">Abortion Reforms of the Long 1960s</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_PART_ONE.vue?c87edb90